import type { PhotoDim } from "@/data/schools";
import type { IdentityId, SchoolId } from "@/types/navigation";

/** 固定路径静态图加版本query，避免CDN/微信长期缓存旧PNG */
export function withAssetVersion(path: string): string {
  const sep = path.includes("?") ? "&" : "?";
  return `${path}${sep}v=${__ASSET_VERSION__}`;
}

/** JSON内路径 `images/...` → 静态资源URL（文件放 `public/images/...`） */
export function contentAssetUrl(jsonPath: string | undefined): string | undefined {
  if (!jsonPath?.trim()) return undefined;
  const p = jsonPath.replace(/^\//, "");
  return withAssetVersion(`/${p}`);
}

/** 站点级占位路径（产品后期同名覆盖即可，无需改代码） */
export const siteAssetPaths = {
  hero: () => withAssetVersion("/images/site/hero-marina.jpg"),
  schoolCampus: (id: SchoolId) =>
    withAssetVersion(`/images/schools/${id}-campus.jpg`),
  wechatQr: () => withAssetVersion("/images/site/wechat-qr.png"),
  butlerAvatar: {
    l: () => withAssetVersion("/images/team/butler-l.png"),
    j: () => withAssetVersion("/images/team/butler-j.png"),
    s: () => withAssetVersion("/images/team/butler-s.png"),
  },
  schoolLogo: (id: SchoolId) => withAssetVersion(`/images/logo/${id}.png`),
  identityScene: (id: Exclude<IdentityId, "other">) =>
    withAssetVersion(`/images/identity/${id}.png`),
} as const;

export const schoolCampusPhotoDim: Record<SchoolId, PhotoDim> = {
  nus: "map",
  ntu: "interior",
  smu: "city",
  jcu: "coral",
  curtin: "map",
};
